function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fill-background",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7425 2.24244L33.7575 17.2575C34.1676 17.6676 34.1676 18.3324 33.7575 18.7424L18.7425 33.7575C18.3324 34.1676 17.6676 34.1676 17.2575 33.7575L2.24246 18.7424C1.83241 18.3324 1.83241 17.6676 2.24246 17.2575L17.2575 2.24244C17.6676 1.83239 18.3324 1.83239 18.7425 2.24244Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fill-foreground",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.875C18.6213 10.875 19.125 11.3787 19.125 12V19.5C19.125 20.1213 18.6213 20.625 18 20.625C17.3787 20.625 16.875 20.1213 16.875 19.5V12C16.875 11.3787 17.3787 10.875 18 10.875ZM18 23.625C18.6213 23.625 19.125 24.1286 19.125 24.75V24.9166C19.125 25.5379 18.6213 26.0416 18 26.0416C17.3787 26.0416 16.875 25.5379 16.875 24.9166V24.75C16.875 24.1286 17.3787 23.625 18 23.625Z",
    fill: "currentColor"
  })));
};
SvgError.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgError"
};
export default SvgError;